module.exports = __webpack_public_path__ + "img/travel-insurance-help.c31d2a05.jpg";